import {
  EventActions,
  EventCategories,
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

export const useAdminFeeTextTracking = () => {
  const trackEvent = useAnalytics((state) => state.trackEvent)

  const onAdminFeeClick = (trackingValue: string) => {
    const evt = {
      event: {
        name: EventNames.click,
        category: EventCategories.adminFee,
        label: 'info',
        action: EventActions.view,
        value: trackingValue,
      },
    }

    trackEvent({
      eventName: 'info',
      data: evt,
      type: TrackingEventTypes.ADOBE,
    })
  }

  return {
    onAdminFeeClick,
  }
}
